module.exports = __webpack_public_path__ + "img/illust_number03.ac33d86.svg";